import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const FacetSearchBox = ({ placeholder , onSearch  })=>/*#__PURE__*/ React.createElement("div", {
        className: "facet-searchbox"
    }, /*#__PURE__*/ React.createElement("input", {
        className: "facet-searchbox__input",
        type: "search",
        onChange: onSearch,
        placeholder: placeholder,
        "aria-label": "Search through filter options",
        "data-t": "facet-searchbox"
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "search",
        className: "facet-searchbox__icon"
    }))
;

export { FacetSearchBox, FacetSearchBox as default };
//# sourceMappingURL=FacetSearchBox.js.map
